// つど後払いの期限日｜ATN-21552
const publicKeys = JSON.parse(process.env.VUE_APP_DUE30_SHOP_PUBLIC_KEY) as string[];

export default {
  getPeriod(shopPublicKey: string | undefined): number {
    return typeof shopPublicKey === 'string' && publicKeys.includes(shopPublicKey) ? 30 : 10;
  },
};
